import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import PersonEditPageRoute from './components/Person/PersonEditPageRoute';
import EntityEditPageRoute from './components/Entity/EntityEditPageRoute';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/person/:id" element={<PersonEditPageRoute />} />
      <Route path="/entity/:id" element={<EntityEditPageRoute />} />
    </Routes>
  </BrowserRouter>
);
